import { b } from './chunk-IMSWER4T.js';

var e=class extends b{URL="product-searches"};

export { e as a };
//# sourceMappingURL=chunk-AMW2JIN4.js.map
//# sourceMappingURL=chunk-AMW2JIN4.js.map